import { getAppLocale } from './getAppLocale';
import type { AppLocales } from '@hub/common';

/** The app locale a link's `?locale=` asks for, or `undefined` without one. */
export const getLinkLocale = (search: string): AppLocales | undefined => {
  const localeParam = new URLSearchParams(search).get('locale');
  return localeParam ? getAppLocale(localeParam) : undefined;
};
